import { useQuery } from '@tanstack/react-query';

import { groupService } from '@/services/group.service';

export const useGetAllGroups = (pageNumber: number) => {
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: ['group', pageNumber],
		queryFn: () => groupService.getAllGroups(pageNumber),
	});
	return {
		groups: data?.data ?? [],
		totalPages: data?.pageCount,
		isLoading,
		isError,
		error,
		refetch,
	};
};
